var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1262 46.3337C20.2746 46.3337 21.2055 45.4009 21.2055 44.2503C21.2055 43.0997 20.2746 42.167 19.1262 42.167C17.9778 42.167 17.0469 43.0997 17.0469 44.2503C17.0469 45.4009 17.9778 46.3337 19.1262 46.3337Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    fill: "none",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9983 46.3337C43.1466 46.3337 44.0776 45.4009 44.0776 44.2503C44.0776 43.0997 43.1466 42.167 41.9983 42.167C40.8499 42.167 39.9189 43.0997 39.9189 44.2503C39.9189 45.4009 40.8499 46.3337 41.9983 46.3337Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    fill: "none",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49121 2.58301H10.8085L16.381 30.4788C16.5712 31.438 17.092 32.2996 17.8522 32.9128C18.6125 33.526 19.5638 33.8517 20.5397 33.833H40.7506C41.7264 33.8517 42.6778 33.526 43.438 32.9128C44.1983 32.2996 44.7191 31.438 44.9092 30.4788L48.2362 12.9997H12.8878",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.02e7394931276e31c33825c03e631002.svg";
export { ForwardRef as ReactComponent };